import { useEffect } from "react";
import { ComparisonSection } from "./components-v3/comparison-section";
import { DesignerFilesSection } from "./components-v3/designer-files-section";
import { DualCtaSection } from "./components-v3/dual-cta-section";
import { HeroSection } from "./components-v3/hero-section";
import { MatchingSection } from "./components-v3/matching-section";
import { PerspectiveSection } from "./components-v3/perspective-section";
import { PillarsSection } from "./components-v3/pillars-section";
import { StatsBarSection } from "./components-v3/stats-bar-section";
import "./styles.scss";

const ensureMetaTag = (name: string) => {
  let tag = document.querySelector(`meta[name=\"${name}\"]`);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }

  return tag;
};

export const LandingPage = () => {
  useEffect(() => {
    document.title =
      "Home Design Guild | Find Top Interior Designers Near You | Curated Matching Service";

    const descriptionTag = ensureMetaTag("description");
    descriptionTag.setAttribute(
      "content",
      "Home Design Guild connects homeowners with vetted, HDG authorized interior designers. Our Smart-Guild Matching pairs you with top interior designers near you based on personality, style, and project. Not a directory — a curated experience."
    );

    const keywordsTag = ensureMetaTag("keywords");
    keywordsTag.setAttribute(
      "content",
      "interior designers near me, top interior designers, interior designer Atlanta, find an interior designer, best interior designers, luxury interior design, interior decorating services, home design services, interior design matching, vetted interior designers"
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("vis");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.05 }
    );

    document.querySelectorAll(".landing-page-v3 .fi").forEach((element) => {
      observer.observe(element);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="landing-page-v3">
      <main>
        <HeroSection />
        <PillarsSection />
        <MatchingSection />
        <DesignerFilesSection />
        <StatsBarSection />
        <ComparisonSection />
        <PerspectiveSection />
        <DualCtaSection />
      </main>
    </div>
  );
};
